/**
 * Ryan O'Dowd
 * 2022-04-02
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      flex: 1,
    },
  };
};

export default getStyles;
